import { Component, OnInit } from '@angular/core';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { ApiPagedTransaction, ApiTransaction, PaginatedTransactionInput, AllInvestmentsListItem } from 'src/app/services/rest-api/rest-api';
import { RestApiService } from 'src/app/services/rest-api/rest-api.service';
import { ToastNotificationService } from 'src/app/services/toast-notification/toast-notification.service';
import { SelectItem, SelectItemTyped } from 'src/app/shared/dropdown/dropdown';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { take } from 'rxjs/operators';
import { ModalService } from 'src/app/services/modal/modal.service';
import { TransactionsPreloaders } from 'src/app/modules/filterable-transactions/filterable-transactions.component';


@Component({
  templateUrl: './money-and-transactions.component.html',
  styleUrls: ['./money-and-transactions.component.scss'],
  standalone: false
})
export class MoneyActionSelectComponent implements OnInit {
  public availableInvestments: SelectItemTyped<number>[] = [];
  public initialInvestment?: SelectItem;
  public totalItems?: number;
  public initialInvestmentId?: string;
  public filteredTransactions: ApiTransaction[] = [];

  public preloaders: TransactionsPreloaders = {
    transactions: true,
    investments: true,
  };

  public constructor(
    public toastService: ToastNotificationService,
    private restApiService: RestApiService,
    private loggerService: LoggerService,
    private route: ActivatedRoute,
    public modalService: ModalService,
  ) { }

  public ngOnInit(): void {
    this.route.paramMap.pipe(take(1)).subscribe((params: ParamMap) => {
      this.initialInvestmentId = params.get('initialInvestmentId') ?? '';
      this.initFiltrations();
    });
  }

  private initFiltrations(): void {
    this.restApiService.getAllInvestments().subscribe({
      error: this.handleInvestmentsError.bind(this),
      next: this.handleInvestmentsData.bind(this),
    });
  }

  private handleInvestmentsError(error: unknown): void {
    this.preloaders.investments = false;
    this.loggerService.error(typeof error === 'function' ? error() : error);
    this.toastService.unknownApiError();
  }

  private handleInvestmentsData(data: AllInvestmentsListItem[]): void {
    this.refillAvailableInvestments(data.filter(investment => investment.depositExists));

    if(this.initialInvestmentId) {
      this.initialInvestment = this.availableInvestments.find(
        investment => this.initialInvestmentId ? investment.value === parseInt(this.initialInvestmentId) : false
      );
    }

    this.preloaders.investments = false;
  }

  public updateData(newOptions: PaginatedTransactionInput): void {
    this.preloaders.transactions = true;

    this.restApiService.getTransactions(newOptions).subscribe({
      error: this.handleTransactionsError.bind(this),
      next: this.handleInitTransactionsData.bind(this),
    });
  }

  private handleTransactionsError(error: unknown): void {
    this.preloaders.transactions = false;
    this.loggerService.error(typeof error === 'function' ? error() : error);
    this.toastService.unknownApiError();
  }

  private handleInitTransactionsData(data: ApiPagedTransaction): void {
    this.totalItems = data.totalCount;
    this.filteredTransactions = data.content;
    this.preloaders.transactions = false;
  }

  private refillAvailableInvestments(data: AllInvestmentsListItem[]) {
    this.availableInvestments = data.map(investment => ({
      label: investment.name,
      value: investment.portfolioId,
    }));
  }
}
